'use client'

import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utilities/ui'

interface CarouselNavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'prev' | 'next'
  children?: ReactNode
}

export function CarouselNavButton({
  direction,
  className,
  children,
  ...props
}: CarouselNavButtonProps) {
  const Icon = direction === 'prev' ? ChevronLeft : ChevronRight

  return (
    <button
      type="button"
      {...props}
      className={cn(
        'inline-flex items-center justify-center h-10 w-10 bg-background-secondary text-foreground transition-colors hover:bg-brand hover:text-white disabled:opacity-30 disabled:cursor-not-allowed',
        className,
      )}
    >
      {children ?? <Icon className="h-5 w-5" />}
    </button>
  )
}
